import script from "./polling-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./polling-modal.vue?vue&type=script&setup=true&lang=js"

import "./polling-modal.vue?vue&type=style&index=0&id=be0e781a&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be0e781a"]])

export default __exports__